import { ApiService } from '@services/ApiService'

import type {
  APIResponse,
  SessionAvailabilityResponse,
  SpecialistInfo,
} from '../types/intent'

class APIService {
  // private baseUrl: string = import.meta.env.VITE_API_BASE_URL

  // private async request<T>(endpoint: string, options?: RequestInit): Promise<APIResponse<T>> {
  //   try {
  //     const response = await fetch(`${this.baseUrl}${endpoint}`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${import.meta.env.VITE_API_TOKEN || ''}`,
  //         ...options?.headers,
  //       },
  //       ...options,
  //     })

  //     if (!response.ok) {
  //       throw new Error(`API Error: ${response.status}`)
  //     }

  //     const data = await response.json()
  //     return {
  //       success: true,
  //       data,
  //     }
  //   } catch (error) {
  //     console.error('API Request failed:', error)
  //     return {
  //       success: false,
  //       error: error instanceof Error ? error.message : 'Unknown error',
  //     }
  //   }
  // }

  // Session Availability API methods
  async findSpecialistByName(specialistName: string): Promise<any> {
    return ApiService.Chatbot.FindSpecialistByName(specialistName)
  }

  async getSessionAvailability(params: any): Promise<any> {
    return ApiService.Chatbot.SpecialistAvailable(params)
  }

  // async getSpecialistsByName(specialistName: string): Promise<APIResponse<SpecialistInfo[]>> {
  //   return await this.request<SpecialistInfo[]>(
  //     `/findSpecialistByName?specialistName=${encodeURIComponent(specialistName)}`,
  //   )
  // }

  // Mock session data
  // getMockSessionData(): SessionAvailabilityResponse {
  //   return {
  //     sessions: [
  //       {
  //         id: 's1',
  //         doctor_name: 'Dr. Peter Smith',
  //         doctor_email: 'peter.smith@hospital.com',
  //         specialty: 'Cardiology',
  //         available_date: '2025-08-15',
  //         available_time: '09:00',
  //         duration: 30,
  //         status: 'available',
  //         location: 'Room 201',
  //         timezone: 'Asia/Ho_Chi_Minh',
  //         notes: 'General consultation',
  //       },
  //       {
  //         id: 's2',
  //         doctor_name: 'Dr. Peter Smith',
  //         doctor_email: 'peter.smith@hospital.com',
  //         specialty: 'Cardiology',
  //         available_date: '2025-08-15',
  //         available_time: '10:30',
  //         duration: 30,
  //         status: 'available',
  //         location: 'Room 201',
  //         timezone: 'Asia/Ho_Chi_Minh',
  //       },
  //       {
  //         id: 's3',
  //         doctor_name: 'Dr. Peter Smith',
  //         doctor_email: 'peter.smith@hospital.com',
  //         specialty: 'Cardiology',
  //         available_date: '2025-08-16',
  //         available_time: '14:00',
  //         duration: 45,
  //         status: 'available',
  //         location: 'Room 201',
  //         timezone: 'Asia/Ho_Chi_Minh',
  //         notes: 'Follow-up consultation',
  //       },
  //       {
  //         id: 's4',
  //         doctor_name: 'Dr. Peter Smith',
  //         doctor_email: 'peter.smith@hospital.com',
  //         specialty: 'Cardiology',
  //         available_date: '2025-08-17',
  //         available_time: '11:00',
  //         duration: 30,
  //         status: 'available',
  //         location: 'Room 201',
  //         timezone: 'Asia/Ho_Chi_Minh',
  //       },
  //       {
  //         id: 's5',
  //         doctor_name: 'Dr. Peter Smith',
  //         doctor_email: 'peter.smith@hospital.com',
  //         specialty: 'Cardiology',
  //         available_date: '2025-08-18',
  //         available_time: '16:30',
  //         duration: 30,
  //         status: 'available',
  //         location: 'Room 201',
  //         timezone: 'Asia/Ho_Chi_Minh',
  //       },
  //     ],
  //     total_count: 8,
  //     doctor_info: {
  //       name: 'Dr. Peter Smith',
  //       email: 'peter.smith@hospital.com',
  //       specialty: 'Cardiology',
  //     },
  //   }
  // }
}

export const apiService = new APIService()
